export enum ReferralErrorCode {
  REFERRAL_CLIENT_MISMATCH = 'REFERRAL_CLIENT_MISMATCH',
  USER_DOES_NOT_HAVE_SUBMIT_PERMISSIONS_FOR_USER = 'USER_DOES_NOT_HAVE_SUBMIT_PERMISSIONS_FOR_USER',
  TRANSACTING_AGENT_CANNOT_TRANSACT = 'TRANSACTING_AGENT_CANNOT_TRANSACT',
}

export enum ReferralDocumentsAccess {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
}

export class ReferralError extends Error {}
